window.Products.Stationery = {};
window.Products.Stationery.Stationery = function(){};
window.Products.Stationery.Stationery.inherits(window.Products.Product);
window.Products.Stationery.Stationery.dpi = 300;